import { render, staticRenderFns } from "./lists-table.vue?vue&type=template&id=22646120"
import script from "./lists-table.vue?vue&type=script&lang=js"
export * from "./lists-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports